import fetcher from '@/core/lib/fetcher'
import {
  queryOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { APIError, APIResponse } from '@/core/types/utils'
import { PromoCode, PromoCodeFormValues } from './promoCode.types'
import { toast } from '@/core/components/ui/use-toast'

export const promoCodeQueryOptions = (siteId: string, token: string) =>
  queryOptions({
    queryKey: ['promoCodes', siteId, token],
    queryFn: () =>
      fetcher
        .auth(`Bearer ${token}`)
        .get(
          import.meta.env.VITE_API_BOOKING + `property/${siteId}/promo-codes`
        )
        .json<Promise<APIResponse<PromoCode[]>>>(),
  })

export const promoCodeByIdQueryOptions = (promoCodeId: string, token: string) =>
  queryOptions({
    queryKey: ['promoCode', promoCodeId, token],
    queryFn: () =>
      fetcher
        .auth(`Bearer ${token}`)
        .get(
          import.meta.env.VITE_API_BOOKING +
            `property/promo-codes/${promoCodeId}`
        )
        .json<Promise<APIResponse<PromoCode>>>(),
  })

export const createPromoCode = (
  promoCode: PromoCodeFormValues,
  siteId: string,
  token: string
) =>
  fetcher
    .auth(`Bearer ${token}`)
    .url(import.meta.env.VITE_API_BOOKING + `property/${siteId}/promo-codes`)
    .post(promoCode)
    .json()

export const updatePromoCode = (
  data: PromoCodeFormValues,
  promoCodeId: string,
  token: string
) =>
  fetcher
    .auth(`Bearer ${token}`)
    .url(
      import.meta.env.VITE_API_BOOKING + `property/promo-codes/${promoCodeId}`
    )
    .put(data)
    .json()

export const useDeletePromoCode = (token: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) =>
      fetcher
        .auth(`Bearer ${token}`)
        .url(import.meta.env.VITE_API_BOOKING + `property/promo-codes/${id}`)
        .delete()
        .json(),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['promoCodes'],
      })
         void queryClient.invalidateQueries({
        queryKey: ['rates'],
      })
      void queryClient.invalidateQueries({
        queryKey: ['rate'],
      })
      void queryClient.invalidateQueries({
        queryKey: ['package'],
      })
      void queryClient.invalidateQueries({
        queryKey: ['packages'],
      })
      void queryClient.invalidateQueries({
        queryKey: ['activities'],
      })
      void queryClient.invalidateQueries({
        queryKey: ['activity'],
      })
    },
    onError: (error) => {
      const errorObject: APIError<null> = JSON.parse(error.message)
      const errorMessage = errorObject.message

      toast({
        title: 'Error',
        description: errorMessage,
        variant: 'destructive',
      })
    },
  })
}
